<template>
  <div>
    <div class="row margin-half-top">
      <div class="col-md-12">
        <div class="">
          <div class="card-header">
            <btn-rounded
              label="GERAL"
              event="showView"
              params="geral"
              :fill="this.activeView === 'geral'"
            />
            
            <btn-rounded
              label="WHATSAPP"
              event="showView"
              params="whatsapp"
              :fill="this.activeView === 'whatsapp'"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.activeView === 'geral'" class="row">
      <div class="col-md-12">
        <div class="col-md-1">
          <button
            class="btn btn-rounded btn-fill"
            :class="[
              { ' btn-success': !localReadonly },
              { ' btn-warning': localReadonly },
            ]"
            style="padding-left: 10px; padding-right: 10px"
            v-on:click="unlock()"
          >
            <i
              :class="[
                { 'ti-unlock': !localReadonly },
                { 'ti-lock': localReadonly },
              ]"
            ></i>
          </button>
        </div>

        <div class="col-md-12">
          <settings-form
            :data="this.data"
            :readonly="localReadonly"
            :edit="true"
          />
        </div>

        <div class="col-md-12 text-right">
          <btn-rounded label="SALVAR" event="save" />
        </div>
      </div>
    </div>

    <div v-if="this.activeView === 'whatsapp'">
      <div style="display: flex">
        <btn-rounded
          style="margin-right: 4px"
          label="PRINCIPAL"
          event="chatView"
          :params="this.data"
          activeColor="success"
          :fill="this.activeChatView === this.data.priority"
        />
        <!-- <div
          style="margin-right: 4px"
          v-for="(item, index) in this.data.extras"
          :key="index"
        >
          <btn-rounded
            activeColor="success"
            event="chatView"
            eventIcon="deleteWhatsAppExtras"
            :settings="true"
            :params="item"
            :label="
              item.phone != ''
                ? item.formattedPhone
                : 'AUXILIAR ' + item.priority
            "
            :fill="activeChatView === item.priority"
          />
        </div>
        <btn-rounded
          activeColor="success"
          event="addNewWhatsapp"
          icon="fa fa-plus"
          :fill="false"
        /> -->
      </div>

      <div
        style="width: -webkit-fill-available"
        v-if="this.data && this.activeChatView === this.data.priority"
      >
        <!-- Primeira linha com dois col-md-3 -->
        <div class="row">
          <div
            class="col-md-5 card"
            style="padding: 20px; margin: 10px 2px 10px 10px"
          >
            <h4 class="title">WhatsApp</h4>
            <span>&nbsp;QRCode&nbsp;</span>
            <br /><br />
            <div style="text-align: center">
              <btn-rounded
                v-if="isConnectedMain == true"
                label="DESCONECTAR"
                event="WhatsApp"
                style="margin-left: auto; margin-right: auto; display: block"
              />
              <img
                height="300"
                width="300"
                v-if="isConnectedMain == false"
                :src="
                  qrCodeImageMain != null
                    ? qrCodeImageMain
                    : 'static/img/loading.gif'
                "
                alt=""
                style="margin-left: auto; margin-right: auto; display: block"
              />
              <br />
              <font v-if="isConnectedMain == true" style="font-size: 16px">
                CONECTADO AO TELEFONE:
              </font>
              <span class="link" v-if="isConnectedMain == true">
                <a
                  :href="'https://wa.me/' + data.phone + '?text=Olá!'"
                  target="_blank"
                >
                  {{ data.formattedPhone }}
                </a>
              </span>
              <btn-rounded
                v-if="isConnectedMain == false"
                label="ATUALIZAR"
                event="forceQRCode"
              />
            </div>
          </div>
        </div>

        <!-- Segunda linha com o col-md-6 abaixo dos anteriores -->
        <!-- <div class="row">
          <div class="col-md-5 card" style="padding: 20px; margin: 10px">
            <span>Modo de atendimento</span>
            <br /><br />
            <div class="row text-center">
              <div class="col-md-4">
                <fg-switch
                  v-model="data.isBotWhatsapp"
                  text-enabled="Automatizado"
                  text-disabled="Automatizado"
                  type-bold="true"
                  theme="default"
                  color="red"
                />
              </div>
              <div class="col-md-4">
                <fg-switch
                  v-model="data.isChatWhatsapp"
                  text-enabled="Manual"
                  text-disabled="Manual"
                  type-bold="true"
                  theme="default"
                  color="red"
                />
              </div>
              <div class="col-md-4">
                <fg-switch
                  v-model="data.isNotifyWhatsapp"
                  text-enabled="Notificações"
                  text-disabled="Notificações"
                  type-bold="true"
                  theme="default"
                  color="red"
                />
              </div>
            </div>

            <div class="text-center">
              <br />
              <btn-rounded label="SALVAR" event="saveData" :params="data" />
            </div>
          </div>
        </div> -->
      </div>

      <!-- <div
        v-for="(item, index) in this.data.extras"
        :key="index"
        style="display: inline-grid; width: -webkit-fill-available"
        v-if="activeChatView === item.priority"
      >
        <div class="row">
          <div class="col-md-3 card" style="padding: 20px; margin: 10px">
            <h4 class="title" slot="title">WhatsApp</h4>
            <span slot="subTitle">&nbsp;QRCode&nbsp;</span>
            <br /><br />
            <div style="text-align: center">
              <btn-rounded
                v-if="getConnectedStatus(item)"
                label="DESCONECTAR"
                :params="item"
                event="WhatsAppExtras"
                style="margin-left: auto; margin-right: auto; display: block"
              />
              <img
                height="300"
                width="300"
                v-else
                :src="getQRCodeImage(item)"
                alt=""
                style="margin-left: auto; margin-right: auto; display: block"
              />
              <br />
              <font v-if="getUpdateQrCode(item)" style="font-size: 16px"
                >CONECTADO AO TELEFONE:
              </font>
              <span class="link" v-if="getUpdateQrCode(item)"
                ><a
                  :href="'https://wa.me/' + item.phone + '?text=Olá!'"
                  target="_blank"
                  >{{ item.formattedPhone }}</a
                ></span
              >
              <btn-rounded
                v-else
                label="ATUALIZAR"
                :params="item"
                event="forceQRCodeExtras"
              />
            </div>
          </div>
        </div>
      </div> -->
    </div>

  </div>
</template>

<script>
import SettingsForm from "src/components/UIComponents/Forms/SettingsForm.vue";
import formConfirmButton from "src/components/UIComponents/Inputs/formConfirmButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Notifications from "vue-notification";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import io from "socket.io-client";
import Vue from "vue";
import moment from "moment";

import { NAMES } from "../../../../config";
var ws = NAMES.fullUrl.substr(0, NAMES.fullUrl.length - 1);


Vue.use(Notifications);
Vue.use(Viewer);

export default {
  components: {
    SettingsForm,
    formConfirmButton,
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  props: {},
  computed: {
    ...mapState({}),
  },
  watch: {
    $route: "initData",
    newQRCode: function (val) {
      if (val === true) {
        this.newQRCode = false;
      }
    },
  },

  methods: {
    ...mapActions(["getSettings", "updateSettings", "refreshQRCode","exitWhatsApp","forceWhatsApp",]),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),
    initData() {
      this.getSettings()
        .then((settings) => {
          this.data = settings.data;
          // this.data.formattedCommissionPercentual = "% " + this.data.formattedCommissionPercentual.onlyNumber();
          this.data.formattedCommissionPercentual = parseInt(
            "" + this.data.commissionPercentualCentavos
          ).int2Money(2, "% ");

          // this.data.extras.sort((a, b) => a.priority - b.priority);
          this.activeChatView = this.data.priority;

          this.qrCodeData();
        })
        .catch((err) => {
          console.log(err);
        });


        this.socket = io(ws, {
        reconnection: true,
        reconnectionAttempts: "Infinity",
        reconnectionDelay: 5000,
        transports: ["websocket", "polling", "flashsocket"],
      });

      this.socket.on(
        "chatMessage",
        function (body) {
          console.log(body);

          if (body.priority == this.activeChatView) {
            var isConnected = false;
            if (body.priority == 1) {
              this.isConnectedMain = body.connected === true;
              isConnected = this.isConnectedMain;

              // ROTINA PARA ATUALIZAR O NOME DA ABA REMOVENDO O NÚMERO DE TELEFONE QUANDO DESCONECTAR
              if (isConnected !== true) {
                this.data.phone = "";
              } else {
                if (body.event === "ready") {
                  this.data.phone = body.phone;
                  this.data.formattedPhone = body.formattedPhone;
                }
              }
            } else {
              if (!this.extras.find((e) => e.priority == body.priority)) {
                return;
              }
              this.extras.find((e) => e.priority == body.priority).isConnected =
                body.connected === true;
              isConnected = this.extras.find(
                (e) => e.priority == body.priority
              ).isConnected;

              // ROTINA PARA ATUALIZAR O NOME DA ABA REMOVENDO O NÚMERO DE TELEFONE QUANDO DESCONECTAR
              if (isConnected !== true) {
                this.data.extras.find(
                  (e) => e.priority == body.priority
                ).phone = "";
              } else {
                if (body.event === "ready") {
                  this.data.extras.find(
                    (e) => e.priority == body.priority
                  ).phone = body.phone;
                  this.data.extras.find(
                    (e) => e.priority == body.priority
                  ).formattedPhone = body.formattedPhone;
                }
              }
            }

            if (body.event === "qr" && body.priority === this.priority) {
              clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
              if (isConnected === false) {
                this.refreshQRCode().then((res) => {
                  if (body.priority == 1) {
                    this.qrCodeImageMain = res.body.qrcode;
                  } else {
                    if (this.extras.find((e) => e.priority == body.priority)) {
                      this.extras.find(
                        (e) => e.priority == body.priority
                      ).qrcode = res.body.extras.find(
                        (e) => e.priority == body.priority
                      ).qrcode;
                    }
                  }

                  // ROTINA PARA ATUALIZAR O NOME DA ABA INCLUINDO O NÚMERO DE TELEFONE QUANDO CONECTAR
                  // if (isConnected === true) {
                  //   this.getParams().then((settings) => {
                  //     this.data = settings.data;
                  //     this.data.extras.sort((a,b) => a.priority - b.priority)
                  //   });
                  // }

                  this.newQRCode = true;
                });
              }
            }, 3000);
          }
        }.bind(this)
      );

      this.socket.on(
        "connect",
        function () {
          console.log("QRCode conectado.");

          this.socket.emit("joinRoom", { id: "qrcode" });
        }.bind(this)
      );

      this.socket.on("disconnect", function (err) {
        console.error("QRCode desconectado.", err);
      });

      this.socket.on("error", function (err) {
        console.error("QRCode error.", err);
      });
    },

    getConnectedStatus(data) {
      return this.extras.find((item) => item.priority === data.priority)
        .isConnected;
    },
    getQRCodeImage(data) {
      if (this.extras.find((item) => item.priority === data.priority).qrcode) {
        return this.extras.find((item) => item.priority === data.priority)
          .qrcode;
      } else {
        return "static/img/loading.gif";
      }
    },

    getUpdateQrCode(data) {
      return this.extras.find((item) => item.priority === data.priority)
        .isConnected;
    },

    qrCodeData() {
      this.refreshQRCode().then((res) => {
        console.log(res)
        this.qrCodeImageMain = res.body.qrcode;
        this.isConnectedMain = res.body.isConnected;

        this.extras = [];
        for (let i = 0; i < res.body.extras.length; i++) {
          this.extras.push({
            priority: res.body.extras[i].priority,
            qrcode: res.body.extras[i].qrcode,
            isConnected: res.body.extras[i].isConnected,
          });
        }

        this.getSettings().then((settings) => {
          this.data = settings.data;
          // if (this.data.extras.length > 0)  {this.data.extras.sort((a, b) => a.priority - b.priority)} ;
        });
      });
    },

    unlock() {
      if (this.sidebarFlag() === "ADMIN") {
        this.localReadonly = !this.localReadonly;
      } else {
        this.localReadonly = true;
      }
    },
  },

  data() {
    return {
      localReadonly: false,
      data: {},
      readonly: true,
      timer: undefined,
      priority: undefined,
      activeView: "geral",
      activeChatView: 1,
      localReadonly: false,
      isNewWhatsapp: false,
      newQRCode: false,
      qrCodeImageMain: null,
      isConnectedMain: false,
      extras: [],
    };
  },

  created() {
    if (this.$route.params.activeView) {
      this.activeView = this.$route.params.activeView;
    }
    this.initData();
    this.localReadonly = this.readonly;

    this.$on("save", () => {
      this.updateSettings(this.data)
        .then((res) => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: "Configurações salva com sucesso!",
            position: "top center",
            type: "success",
          });
          this.localReadonly = true;
        })
        .catch((res) => {
          this.$notify({
            group: "foo",
            title: "Error",
            text: "Erro na hora de salvar",
            position: "top center",
            type: "error",
          });
        });
    });

    this.$on("showView", (view) => {
      this.activeView = view;
    });

    this.$on("saveData", (item) => {
      this.updateSettings(item).then((res) => {
        this.getSettings().then((settings) => {
          this.data = settings.data;
          // this.data.extras.sort((a, b) => a.priority - b.priority);

          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: "Configuração salva com sucesso!",
            position: "top center",
            type: "success",
          });
        });
      });
    });

    this.$on("WhatsApp", () => {
      this.exitWhatsApp().then((res) => {
        this.qrCodeImageMain = null;
        this.isConnectedMain = false;
        this.data.phone = "";
        // this.getParams().then((settings) => {
        //   this.data = settings.data;
        //   this.data.extras.sort((a,b) => a.priority - b.priority)
        // });
      });
    });

    this.$on("WhatsAppExtras", (item) => {
      this.exitWhatsApp({ priority: item.priority }).then((res) => {
        this.extras.find((e) => e.priority == item.priority).qrcode = null;
        this.extras.find((e) => e.priority == item.priority).isConnected = null;
        item.phone = "";

        // this.getParams().then((settings) => {
        //   this.data = settings.data;
        //   this.data.extras.sort((a,b) => a.priority - b.priority)
        // });
      });
    });

    this.$on("forceQRCode", () => {
      this.qrCodeImageMain = null;
      this.isConnectedMain = false;
      this.forceWhatsApp();
    });

    this.$on("forceQRCodeExtras", (item) => {
      this.extras.find((e) => e.priority == item.priority).qrcode = null;
      this.extras.find((e) => e.priority == item.priority).isConnected = null;
      this.forceWhatsApp({ priority: item.priority });
    });
  },

  beforeDestroy() {
    this.socket.disconnect();
  },
};
</script>

<style lang="scss" scoped>
.card-image {
  border: solid 1px white;
  padding: 15px;
  background-color: #f0f0f0;
}

.link {
  color: red;
  font-size: 16px;
  cursor: pointer;
}

.link a {
  color: red;
}

.rotateimg90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.rotateimg180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

.rotateimg270 {
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  transform: rotate(270deg);
}

.images {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/SettingsEdit.vue